export enum ButtonColor {
	PRIMARY = 'btn-primary',
	SECONDARY = 'btn-secondary',
	SUCCESS = 'btn-success',
	DANGER = 'btn-danger',
	WARNING = 'btn-warning',
	INFO = 'btn-info',
	WHITE = 'btn-white',
	DARK = 'btn-dark',
	LINK = 'btn-link',
	NONE = 'btn-none',
	COMPACT = 'btn-none btn-compact'
}